<template>
	<div class="seomain">
	  <st-header
	    :title="formData.id ? '编辑客户' : '添加客户'"
	    :back-able="true"
	  >
	  </st-header>
		<van-steps :active="act_step">
		  <van-step><div @click="act_step = 0">客户类型</div></van-step>
		  <van-step @click="act_step = 1"><div @click="act_step = 1">客户信息</div></van-step>
			<van-step>提交</van-step>
		</van-steps>
	  <div class="st-form-content">
	    <st-form ref="form">
				
				<div class="st-form-group" v-show="act_step == 0">
					 <van-cell-group inset>
						 <st-form-item key="type" label="客户类型" prop="type" :required="true">
							 <st-select
								 v-model="formData.type"
								 name="客户类型"
								 placeholder="请选择客户类型"
								 :options="$option['customer_type']"
							 >
							 </st-select>
						 </st-form-item>
						 
						 <st-form-item key="quota_switch" label="额度开关" prop="quota_switch">
							 <van-switch v-model="formData.quota_switch" />
						 </st-form-item>
						 
						 <div style="margin: 16px;" class="form-submit-button">
							 <van-button round block type="primary"  @click="act_step++">
								 下一步
							 </van-button>
						 </div>
						 
					 </van-cell-group>
				</div>
				
				 
				 <div v-show="act_step == 1">
					 <div class="st-form-title">基本信息</div>
					 <div class="st-form-group">
					 	<van-cell-group inset>
					 	
					 		<st-form-item key="country_id" label="国家" prop="country_id">
					 			 <van-field
					 				 class="st-form-item-input"
					 				 v-model="formData.country_id"
					 				 name="国家"
					 				 label=""
					 				 placeholder="请填写国家"
					 			 />
					 		</st-form-item>
					 		
							<st-form-item key="is_overseas" label="区域" prop="is_overseas" :required="true">
							 <st-select
								 v-model="formData.is_overseas"
								 name="区域"
								 placeholder="请选择区域"
								 :options="$option['option_is_overseas']"
							 >
							 </st-select>
							</st-form-item>
							
							<st-form-item key="name" label="客户名称" prop="name">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.name"
									 name="客户名称"
									 label=""
									 placeholder="请填写客户名称"
								 />
							</st-form-item>
							
					 		<st-form-item key="seller" label="客户经理" prop="seller" :required="true">
					 		 <st-select
					 			 v-model="formData.seller"
					 			 name="客户经理"
					 			 placeholder="请选择客户经理"
					 			 :options="$option['getUserList']"
					 		 >
					 		 </st-select>
					 		</st-form-item>
							
							<st-form-item key="taxpayer_type" label="纳税人类型" prop="taxpayer_type" :required="true">
							 <st-select
								 v-model="formData.taxpayer_type"
								 name="纳税人类型"
								 placeholder="请选择纳税人类型"
								 :options="$option['getModelConf']('clienter', 'taxpayerType')"
								 :filterable="false"
							 >
							 </st-select>
							</st-form-item>
							
							<st-form-item key="code" label="客户代码" prop="code">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.code"
									 name="客户代码"
									 label=""
									 placeholder="请填写客户代码"
								 />
							</st-form-item>
							
							<st-form-item key="abbreviation" label="客户简称" prop="abbreviation">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.abbreviation"
									 name="客户简称"
									 label=""
									 placeholder="请填写客户简称"
								 />
							</st-form-item>
							
							<st-form-item key="developmentdate" label="开发日期" prop="developmentdate" :required="true">
								<st-date
									v-model="formData.developmentdate"
									name="开发日期"
									placeholder="请选择开发日期"
								></st-date>
							</st-form-item>
							
							<st-form-item key="city" label="城市" prop="city">
								<st-area
									v-model="formData.city"
									name="城市"
									placeholder="请选择城市"
								>
								</st-area>
							</st-form-item>
							
							<st-form-item key="address" label="详细地址" prop="address">
								<van-field
									class="st-form-item-input"
									v-model="formData.address"
									name="详细地址"
									label=""
									placeholder="请填写详细地址"
									type="textarea"
								/>
							</st-form-item>
							
							<st-form-item key="contactone" label="联系人" prop="contactone" :required="true">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.contactone"
									 name="联系人"
									 label=""
									 placeholder="请填写联系人"
								 />
							</st-form-item>
						
							<st-form-item key="contactonenumber" label="联系方式" prop="contactonenumber" :required="true">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.contactonenumber"
									 name="联系方式"
									 label=""
									 placeholder="请填写联系方式"
								 />
							</st-form-item>
							
							<st-form-item key="emailone" label="Email" prop="emailone">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.emailone"
									 name="Email"
									 label=""
									 placeholder="请填写Email"
								 />
							</st-form-item>
						
							<st-form-item key="qqone" label="QQ" prop="qqone">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.qqone"
									 name="QQ"
									 label=""
									 placeholder="请填写QQ"
								 />
							</st-form-item>
						
							<st-form-item key="wechatone" label="Wechat" prop="wechatone">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.wechatone"
									 name="Wechat"
									 label=""
									 placeholder="请填写Wechat"
								 />
							</st-form-item>
							
							<st-form-item key="whatsappone" label="Whatsapp" prop="whatsappone">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.whatsappone"
									 name="Whatsapp"
									 label=""
									 placeholder="请填写Whatsapp"
								 />
							</st-form-item>
							
							<st-form-item key="settlementmethod" label="结算方式" prop="settlementmethod">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.settlementmethod"
									 name="结算方式"
									 label=""
									 placeholder="请填写结算方式"
								 />
							</st-form-item>
							
							<st-form-item key="swiftcode" label="Swift Code" prop="swiftcode">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.swiftcode"
									 name="Swift Code"
									 label=""
									 placeholder="请填写Swift Code"
								 />
							</st-form-item>
							
							<st-form-item key="billingnote" label="结算备注" prop="billingnote">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.billingnote"
									 name="结算备注"
									 label=""
									 placeholder="请填写结算备注"
								 />
							</st-form-item>
						
							<st-form-item key="remarks" label="备注" prop="remarks">
								 <van-field
									 class="st-form-item-input"
									 v-model="formData.remarks"
									 name="备注"
									 label=""
									 placeholder="请填写备注"
								 />
							</st-form-item>
							
							<st-form-item key="business_card" label="上传名片" prop="business_card" :required="true">
								<st-file-upload
									name="名片"
									v-model="formData['business_card']"
								>
								</st-file-upload>
							</st-form-item>
						
							<st-form-item key="data_files" label="营业执照/BR" prop="data_files" :required="true">
								<st-file-upload
									name="营业执照/BR"
									v-model="formData['data_files']"
								>
								</st-file-upload>
							</st-form-item>
					 
					  </van-cell-group>
					 </div>
					 
					 <div class="st-form-title" v-if="formData.is_overseas === '1'">开票信息</div>
					 <div class="st-form-group" v-if="formData.is_overseas === '1'">
							<van-cell-group inset>
								<st-form-item key="remittancecompanyname" label="账户名称" prop="remittancecompanyname" :required="true">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.remittancecompanyname"
										 name="账户名称"
										 label=""
										 placeholder="请填写账户名称"
									 />
								</st-form-item>
								
								<st-form-item key="taxidentificationnumber" label="纳税识别号" prop="taxidentificationnumber" :required="true">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.taxidentificationnumber"
										 name="纳税识别号"
										 label=""
										 placeholder="请填写纳税识别号"
									 />
								</st-form-item>
								
								<st-form-item key="remittancebankname" label="开户行" prop="remittancebankname" :required="true">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.remittancebankname"
										 name="开户行"
										 label=""
										 placeholder="请填写开户行"
									 />
								</st-form-item>
								
								<st-form-item key="remittancebankaccount" label="银行账号" prop="remittancebankaccount" :required="true">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.remittancebankaccount"
										 name="银行账号"
										 label=""
										 placeholder="请填写银行账号"
									 />
								</st-form-item>
								
								<st-form-item key="remittancebankaddress" label="工商注册地址" prop="remittancebankaddress" :required="true">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.remittancebankaddress"
										 name="工商注册地址"
										 label=""
										 placeholder="请填写工商注册地址"
									 />
								</st-form-item>
								
								<st-form-item key="invoicetel" label="联系电话" prop="invoicetel" :required="true">
									 <van-field
										 class="st-form-item-input"
										 v-model="formData.invoicetel"
										 name="联系电话"
										 label=""
										 placeholder="请填写联系电话"
									 />
								</st-form-item>
								
							</van-cell-group>
					 </div>
					 <div style="width: 100vw;bottom: 0;position: sticky;margin-left: -30px;padding: 8px 0px 16px;background: rgba(202,192,192, 0.5)">
						 <div class="form-submit-button" style="margin: 0px 16px;">
							 <van-button round block type="default"  @click="act_step--">
							 	 上一步
							  </van-button>
							 <van-button round block type="primary"  @click="onSubmit">
							 	提交
							 </van-button>
						 </div>
					 	
					 </div>
				 </div>
				 
			</st-form>
		</div>
	</div>
</template>

<script>
	import StHeader from "@/components/layout/Header.vue";
	import StFormItem from "@/components/formItem.vue";
	import StForm from "@/components/form.vue";
	import StFileUpload from "@/components/FileUpload.vue";
	import StSelect from "@/components/Select.vue";
	import StDate from "@/components/Date.vue";
	import StArea from "@/components/Area.vue";

	export default {
		components: {
			StHeader,
			StFormItem,
			StForm,
			StFileUpload,
			StSelect,
			StDate,
			StArea,
			floading: false,
		},
		props: {},
		data() {
		  return {
				act_step: 0,
		    formData: {
					is_overseas: '1',
					quota_switch: false,
				},
			}
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		    init() {
					let query = this.$route.query;
					if (query.id) this.formData.id = query.id;
					this.getInfo();
		    },
				getInfo() {
						if(!this.formData.id) {
							return;
						}
						this.floading = true;
						
						this.$post(this.$api.stCustomerInfo, {id: this.formData.id}).then((res) => {
							if (res.code != 1) {
								this.$toast.fail(res.msg ? res.msg : '获取异常');
								return;
							}
							let data = res.data;
							let formData = {
								'id': this.formData.id,
								'is_overseas': data.is_overseas ? data.is_overseas.toString() : '',
								'business_card': data.business_card,
								'data_files': data.data_files,
								'type': data.type,
								'quota_switch': data.quota_switch ? true : false,
								'country_id': data.country_id,
								'name': data.name,
								'seller': data.seller,
								'taxpayer_type': data.taxpayer_type,
								'code': data.code,
								'city': data.city,
								'developmentdate': data.developmentdate,
								'abbreviation': data.abbreviation,
								'address': data.address,
								'contactone': data.contactone,
								'contactonenumber': data.contactonenumber,
								'emailone': data.emailone,
								'qqone': data.qqone,
								'whatsappone': data.whatsappone,
								'settlementmethod': data.settlementmethod,
								'swiftcode': data.swiftcode,
								'billingnote': data.billingnote,
								'remarks': data.remarks,
								'remittancecompanyname': data.remittancecompanyname,
								'taxidentificationnumber': data.taxidentificationnumber,
								'remittancebankname': data.remittancebankname,
								'remittancebankaccount': data.remittancebankaccount,
								'remittancebankaddress': data.remittancebankaddress,
								'invoicetel': data.invoicetel,
								'wechatone': data.wechatone,
							};
							this.$set(this, ['formData'], formData);
							this.floading = false;
						});
				},
				
		    // 提交代码
		    onSubmit() {
		      let formValid = false;
		      this.$refs.form.validater.valid((isValid, lastMsg) => { 
		        formValid = isValid;
		        if (!isValid) {
		          this.$toast.fail('表单异常：' + lastMsg);
		        }
		      });
		      // 校验不通过
		      if (!formValid) return;
		      let formData = JSON.parse(JSON.stringify(this.formData));
					if (!this.formData.id) {
						this.$post(this.$api.stCustomerAdd, formData).then((res) => {
						  if (res.code !== 1) {
						    this.$toast.fail(res.msg ? res.msg : '保存异常');
						  } else {
						    this.$toast.success("创建客户成功");
						    this.$router.replace('/customer/list');
						  }
						});
					} else {
						this.$post(this.$api.stCustomerEdit, formData).then((res) => {
						  if (res.code !== 1) {
						    this.$toast.fail(res.msg ? res.msg : '保存异常');
						  } else {
						    this.$toast.success("编辑客户成功");
						    this.$router.replace('/customer/list');
						  }
						});
					}
		      
		      
		    },
		  },
		
	}
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;

  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
		padding: 20px 0px;
		border-radius: 5px;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .product-item {
      background-color: rgba(230, 236, 241, 1);
      padding: 15px;
      margin-top: 18px;

      .prudcut-del-box {
        margin-top: -10px;
        float: right;
        text-align: right;
        font-size: 31px;
        color: rgba(227, 60, 100, 1);
      }
    }

    .new-pruduct-btn {
      width: 317px;
      height: 44px;
      border-radius: 5px;
      color: rgba(80, 80, 80, 1);
      background: rgba(42, 130, 228, 1);
      line-height: 150%;
      border: none;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;

      .el-icon-plus {
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-weight: bolder;
      }
    }
  }

	.form-submit-button {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-bettwen;
		gap: 10px;
		button {
			min-width: 45%;
			flex: 1;
		}
	}

  .static {
    display: flex;
    justify-content: space-around;
    height: 70px;
    background-color: rgba(56, 56, 56, 1);
    font-size: 14px;
    line-height: 150%;
    align-items: center;

    div {
      text-align: center;
    }

    border-radius: 0px,0px,5px,5px;
  }
}

</style>
